import React, { useEffect, FunctionComponent, JSXElementConstructor } from 'react'

import cx from 'classnames'
import { isFunction } from 'libraries/lodash'

import { FLAVOUR_COLORS } from 'constants/flavours'
import TopLevelAccordionContainer from 'redux/containers/components/accordion/TopLevelAccordionContainer'
import useAccordionFound from 'hooks/useAccordionFound'
import { AccordionFoundContainerProps } from 'redux/containers/components/accordion/AccordionFoundContainer'
import { AccordionWrapperProps } from '.'
import { Flavour } from 'types/Flavour'
import tileOverrides from 'constants/tile-overrides'

const AccordionFound:FunctionComponent<AccordionFoundProps> = ({
  group,
  adminBar,
  eventCategory,
  flavour,
  contained = false,
  SectionHeaderOverride = null,
  section,
  expandedNodeTitle,
  cxNames,
  showAllS1,
  copyright,
  setAccordionIsLoaded,
  isAccordionLoaded,
  ...props
}) => {
  const flavourColor = eventCategory === 'Q&A' ? FLAVOUR_COLORS[flavour as Flavour] : null // FIX ME
  const { borderColor = '', accordionContainer = '' } = cxNames
  const SectionHeaderToUse: JSXElementConstructor<SectionHeaderProps> = SectionHeaderOverride || SectionHeader
  const { scrollToRef } = useAccordionFound()

  useEffect(() => {
    setAccordionIsLoaded(true)
    return () => {
      setAccordionIsLoaded(false)
    }
  }, [])

  return (
    <div ref={scrollToRef} className={cx('content-view', { dn: !isAccordionLoaded })}>
      <>
      <Title {...props} />
      {adminBar}
      <div className={!contained ? 'layout-width-constraint' : ''}>
        <div className={accordionContainer}>
          <SectionHeaderToUse {...{ section, flavourColor, borderColor, expandedNodeTitle }} />
          <TopLevelAccordionContainer {...{ flavourColor, cxNames, showAllS1 }} />
          <div className='sticky' />
          <Footer {...{ copyright }} />
        </div>
      </div>
      </>
    </div>
  )
}

const SectionHeader: FunctionComponent<SectionHeaderProps> = ({ section, expandedNodeTitle, borderColor }) => {
  const header = expandedNodeTitle || section
  const append: string | null = tileOverrides.reduce((prev: string | null, val) => {
    if (val.title === header) {
      return val.append
    }
    return prev
  }, null)

  return (
    <div className={cx('ph6 pt7 pb6 bg-white b f3 bb-thick', borderColor)}>
      {header} {append && <span className='pl6 f5'>{append}</span>}
    </div>
  )
}

const Title = ({ styleTitle = true, ...props }) => {
  const { title, handleExpandedTitleOnClick } = props

  if (!title) {
    return null
  }

  if (isFunction(title) && this) {
    const TitleComponent = (this as any).props.title
    return <TitleComponent {...props} />
  }

  // required as we need to pass an onClick handler for when a user clicks the breadcrumb title of an expanded s1 and
  // collapse the s2 accordion and 'navigate' back to the toplevel s1 accordion)
  const titleComponent = React.cloneElement(title, { ...{ handleExpandedTitleOnClick } })

  return (
    <section key='title' className={cx({ 'ma0 bg-white': styleTitle })}>
      <div className={cx({ 'layout-width-constraint': styleTitle })}>
        {titleComponent}
      </div>
    </section>
  )
}

const Footer:FunctionComponent<FooterProps> = ({ copyright }) => copyright ? <div className='ph8 pt6 f6 lite-grey'>{copyright}</div> : null


interface SectionHeaderProps {
  section: string;
  expandedNodeTitle: string;
  borderColor: string;
}

type FooterProps = Pick<AccordionFoundProps, 'copyright'>

type AccordionFoundProps = AccordionFoundContainerProps & AccordionWrapperProps

export default AccordionFound
